// generated by genversion
export var version = '5.3.18';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/pubsub/node_modules/@aws-amplify/core/lib-esm/Platform/version.js
// module id = null
// module chunks = 